import Vue from "vue"
import i18n from "@/modules/i18n"
import store from "@/store/"
import handleCapturedVueError from "@/utils/handle-captured-vue-error"

export default (params, vueOptions = {}) => {
  const el = params.el instanceof HTMLElement ? params.el : document.querySelector(params.el)

  if (!el) {
    return
  }

  new Vue({
    name: params.component.name,
    el,
    store,
    i18n: i18n,
    render: (h) => {
      return h(params.component, {
        props: params.props
      })
    },
    ...vueOptions,
    errorCaptured: handleCapturedVueError
  })
}
